// extracted by mini-css-extract-plugin
var _1 = "ra-profile-detail-card";
var _2 = "ra-profile-detail-card-paragraph";
export { _1 as "profileDetailCardCls", _2 as "profileDetailCardParagraphCls" }
